module.exports = __webpack_public_path__ + "img/gb10.prt.a0f7284e.jpg";